import React, { FunctionComponent } from 'react'
import { FormError, FormInput, FormLabel, InputProps } from '../Form'
import { SpinLoader } from '../../SpinLoader/SpinLoader'

export const Input: FunctionComponent<InputProps> = props => {
  const {
    fieldName,
    label,
    type,
    register,
    readOnly,
    hasOldAddress,
    registerOptions,
    errors,
    isLoading,
    onChange,
    hidden,
  } = props
  return (
    <>
      <FormLabel>
        {label} {isLoading && <SpinLoader />}
      </FormLabel>
      <FormInput
        readOnly={hasOldAddress ? false : readOnly}
        hidden={hidden}
        onChange={() => {
          onChange && onChange()
        }}
        type={type ? type : 'text'}
        {...register(fieldName, registerOptions)}
      />
      {errors && <FormError>{errors.message}</FormError>}
    </>
  )
}
